/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-first-prop-new-line */
import * as React from 'react'
import {
  IonRow, IonCol, IonLabel, IonCheckbox, IonButton,
} from '@ionic/react'
import {
  ObscureBackground, OverlayContainer, SherpaButton, LineDivider,
} from '../GlobalContainers'
import { useJourneysData2 } from '../../hooks/journeys/useJourneysData2'

const MapFilterPopup = () => {
  const {
    filters, setFilters, paintMBs, drawRoutes, drawAssets, drawAlertStates, showSecurityHeatMap,
    setShowMapFilterPopup,
  } = useJourneysData2()

  const [toggleAll, setToggleAll] = React.useState(
    Object.values(filters).findIndex((param) => !param) < 0,
  )

  React.useEffect(() => {
    setToggleAll(Object.values(filters).findIndex((param) => !param) < 0)
  }, [filters])

  const handleFilter = (name, checked) => {
    const tmpFilters = { ...filters, [name]: checked }
    setFilters(tmpFilters)

    if (!checked) setToggleAll(false)

    if (name === 'mb') paintMBs(checked)
    if (name === 'routes') drawRoutes(checked)
    if (name === 'keyAssets') drawAssets(checked)
    if (name === 'securityHeatMap') showSecurityHeatMap(checked)
    if (name === 'alertStates') drawAlertStates(checked)
  }

  const handleToggleAll = (checked) => {
    paintMBs(checked)
    drawRoutes(checked)
    drawAssets(checked)
    showSecurityHeatMap(checked)
    drawAlertStates(checked)

    setFilters(Object.fromEntries(Object.keys(filters).map((key) => [key, checked])))
    setToggleAll(checked)
  }

  return (
    <>
      <ObscureBackground style={{ zIndex: 20 }} />
      <OverlayContainer style={{
        zIndex: 25, width: '40%', minWidth: '15rem', borderRadius: '1em', overflowY: 'auto', display: 'flex', flexDirection: 'column',
      }} className='terrain-add-popup'
      >
        <IonRow>
          <IonCol size='9'>
            <h5 style={{ fontSize: 14 }}>Map Filter</h5>
          </IonCol>
          <IonCol size='3' style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <SherpaButton style={{ fontSize: '1rem' }} onClick={() => setShowMapFilterPopup(false)}>
              Close X
            </SherpaButton>
          </IonCol>
        </IonRow>
        <IonRow class='ion-align-items-center' style={{ paddingTop: '10px' }}>
          <IonCol size='8'>
            <IonLabel>Toggle all</IonLabel>
          </IonCol>
          <IonCol size='4'>
            <IonCheckbox checked={toggleAll} onClick={(e) => handleToggleAll(e.target.checked)} />
          </IonCol>
        </IonRow>
        <IonRow class='ion-align-items-center' style={{ paddingTop: '10px' }}>
          <IonCol size='8'>
            <IonLabel>Restriction Zones</IonLabel>
          </IonCol>
          <IonCol size='4'>
            <IonCheckbox checked={filters.mb} onClick={(e) => handleFilter('mb', e.target.checked)} />
          </IonCol>
        </IonRow>
        <IonRow class='ion-align-items-center' style={{ paddingTop: '10px' }}>
          <IonCol size='8'>
            <IonLabel>Routes</IonLabel>
          </IonCol>
          <IonCol size='4'>
            <IonCheckbox checked={filters.routes} onClick={(e) => handleFilter('routes', e.target.checked)} />
          </IonCol>
        </IonRow>
        <IonRow class='ion-align-items-center' style={{ paddingTop: '10px' }}>
          <IonCol size='8'>
            <IonLabel>Key Assets</IonLabel>
          </IonCol>
          <IonCol size='4'>
            <IonCheckbox checked={filters.keyAssets} onClick={(e) => handleFilter('keyAssets', e.target.checked)} />
          </IonCol>
        </IonRow>
        <LineDivider />
        <IonRow class='ion-align-items-center' style={{ paddingTop: '10px' }}>
          <IonCol size='8'>
            <IonLabel>Security Heat Map</IonLabel>
          </IonCol>
          <IonCol size='4'>
            <IonCheckbox checked={filters.securityHeatMap} onClick={(e) => handleFilter('securityHeatMap', e.target.checked)} />
          </IonCol>
        </IonRow>
        <IonRow class='ion-align-items-center' style={{ paddingTop: '10px' }}>
          <IonCol size='8'>
            <IonLabel>Alert States</IonLabel>
          </IonCol>
          <IonCol size='4'>
            <IonCheckbox checked={filters.alertStates} onClick={(e) => handleFilter('alertStates', e.target.checked)} />
          </IonCol>
        </IonRow>
        <IonRow style={{ justifyContent: 'flex-end', marginTop: 'auto', paddingTop: '10px' }}>
          <IonButton onClick={() => setShowMapFilterPopup(false)} style={{ '--background': '#0C9500' }}>Done</IonButton>
        </IonRow>
      </OverlayContainer>
    </>
  )
}

export default MapFilterPopup
